import { useAppState } from "src/state";

import { AgencyOperationsAdminTalentViewSchema } from "src/components/agency/operations/administrator/talent/AgencyOperationsAdminTalentViewSchema";

import { Icons } from "src/components/ui/Icons";
import { ViewSchemaRenderer } from "src/components/ui/ViewSchemaRenderer";

export function AgencyOperationsAdminTalentView() {

    const { currentItem } = useAppState().users;

    if (!currentItem) return null;

    return (
        <ViewSchemaRenderer
            schema={AgencyOperationsAdminTalentViewSchema}
            data={currentItem}
            title="Talent Overview"
            icon={Icons.talent}
        />
    );
}